import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));

const Policies = ({ list, handleDownloadDoc, Styled }) => {
  return (
    <Styled.PolicyProcedure>
      <ul className="policyProcedure">
        {list.map((item) => (
          <Row item={item} handleDownloadDoc={handleDownloadDoc} />
        ))}
      </ul>
    </Styled.PolicyProcedure>
  );
};

const Row = ({ item, handleDownloadDoc }) => {
  const downloadDoc = (id) => {
    let str = id;
    let n = str.lastIndexOf('/');
    let result = str.substring(n + 1);
    handleDownloadDoc({
      id: 'downloadPolicies',
      data: result,
    });
  };

  return (
    <li>
      {item.date ? (
        <Label>
          <Link onClick={() => downloadDoc(item.url)}> View </Link>
        </Label>
      ) : (
        <Label variant="body2"> Non Signed</Label>
      )}
      {item.date ? (
        <span className="signedWrapper">
          <Label variant="body1"> {item.name}</Label>
          <Label>Signed {moment(item.date).format('MM/DD/YYYY')}</Label>
        </span>
      ) : (
        <Label variant="body1"> {item.name}</Label>
      )}
    </li>
  );
};

export default Policies;
Policies.propTypes = {
  list: PropTypes.array,
};
